module.exports = __webpack_public_path__ + "static/roche-press-day-3-30d458da4ebadbfcb01abb563622260f.jpg";